import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { ApiWaveCreditScope } from "@/generated/models/ApiWaveCreditScope";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveAuthor from "./WaveAuthor";
import WaveTypeIcon from "./WaveTypeIcon";
import WaveRating from "./WaveRating";
import { WaveIdentitySubmissionSpecsRows } from "./WaveIdentitySubmissionSpecs";
const CREDIT_SCOPE_LABELS: Record<ApiWaveCreditScope, string> = {
  [ApiWaveCreditScope.Wave]: "Whole wave",
  [ApiWaveCreditScope.Drop]: "Each drop"
};
interface WaveSpecsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
export default function WaveSpecs(t0) {
  const $ = _c(21);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "";
  const isChatWave = wave.wave.type === ApiWaveType.Chat;
  const creditScope = wave.voting.credit_scope ?? ApiWaveCreditScope.Wave;
  const creditScopeLabel = CREDIT_SCOPE_LABELS[creditScope] ?? CREDIT_SCOPE_LABELS[ApiWaveCreditScope.Wave];
  const hasVotingDetails = wave.voting.credit_type === ApiWaveCreditType.CardSetTdh || !!wave.voting.credit_category || !!wave.voting.creditor;
  const votingRowAlignmentClass = hasVotingDetails ? "tw-items-start" : "tw-items-center";
  const t2 = `tw-relative tw-overflow-auto tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-6"><p className="tw-mb-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-300">Overview</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-normal tw-text-iron-500">Type</span>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== wave.wave.type) {
    t5 = <div className="tw-group tw-flex tw-min-h-8 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-px-2 tw-py-1 tw-text-sm">{t4}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveTypeIcon waveType={wave.wave.type} /></div></div>;
    $[2] = wave.wave.type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== creditScopeLabel || $[5] !== isChatWave || $[6] !== votingRowAlignmentClass || $[7] !== wave) {
    t6 = !isChatWave && <><div className={`tw-group tw-flex tw-min-h-8 tw-w-full ${votingRowAlignmentClass} tw-justify-between tw-gap-2 tw-px-2 tw-py-1 tw-text-sm`}><span className="tw-font-normal tw-text-iron-500">Voting</span><div className="tw-flex tw-flex-1 tw-justify-end"><WaveRating wave={wave} /></div></div><div className="tw-group tw-flex tw-min-h-8 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-px-2 tw-py-1 tw-text-sm"><span className="tw-font-normal tw-text-iron-500">Voting power</span><span className="tw-self-end tw-font-medium tw-text-iron-50">{creditScopeLabel}</span></div></>;
    $[4] = creditScopeLabel;
    $[5] = isChatWave;
    $[6] = votingRowAlignmentClass;
    $[7] = wave;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="tw-font-normal tw-text-iron-500">Creator</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] !== wave) {
    t8 = <div className="tw-group tw-flex tw-min-h-8 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-px-2 tw-py-1 tw-text-sm">{t7}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveAuthor wave={wave} /></div></div>;
    t9 = <WaveIdentitySubmissionSpecsRows wave={wave} />;
    $[10] = wave;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className="tw-pb-4">{t3}<div className="tw-mt-2.5 tw-flex tw-flex-col tw-gap-y-0.5 tw-px-2">{t5}{t6}{t8}{t9}</div></div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t2) {
    t11 = <div className={t2}>{t10}</div>;
    $[18] = t10;
    $[19] = t2;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}